import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import download from '../../../util/DownloadLink';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  saveDataManagerStatus: null,
  fetchedDataManager: {},
  mediaTypeData: {},
  filterDropDownData: [],
  systemNotesStatus: null,
  userMetrix: '',
  addSuccessMsg: null,
  addRecordData: {},
  addMediaStatus: null,
  isSystemNoteLoading: null,
  usageMedial: {},
  BreDropDownData: {},
  mediaTypePrintStatus: null,
};

const slice = createSlice({
  name: 'dataManager',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchNoteStart: (state) => {
      state.isSystemNoteLoading = true;
      state.errorMsg = null;
    },
    postMediaTypeData: (state, action) => {
      state.addMediaStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
      state.userMetrix = action.payload.response.userMetrix;
    },
    saveDataManager: (state, action) => {
      state.saveDataManagerStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.message;
    },
    postMediaTypeAddData: (state, action) => {
      state.addMediaTypeStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.addRecordData = action.payload.response.placeResponse;
      state.addSuccessMsg = action.payload.message;
      state.userMetrix = action.payload.response.userMetrix;
    },
    postSystemNotesData: (state, action) => {
      state.systemNotesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
      state.isSystemNoteLoading = false;
    },
    getDataManager: (state, action) => {
      state.fetchedDataManager = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    getMediaTypeUsageData: (state, action) => {
      state.usageMedial = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    setMediaTypePrintData: (state, action) => {
      state.isLoading = false;
      state.mediaTypePrintStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    resetMediaUsagedata: (state) => {
      state.usageMedial = {};
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
      state.isSystemNoteLoading = false;
    },
    fetchAddSuccess: (state, action) => {
      state.addSuccessMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ? action.payload.data.message : '';
      state.isLoading = false;
      state.isSystemNoteLoading = false;
    },
    resetStatus: (state, action) => {
      state.addMediaTypeStatus = null;
      state.addMediaStatus = null;
      state.isLoading = false;
      state.mediaTypeData = {};
      state.systemNotesStatus = null;
      state.successMsg = null;
      state.errorMsg = null;
    },
    resetRecordStatus: (state, action) => {
      state.addMediaStatus = null;
      state.addSuccessMsg = null;
    },
    getDropDownData: (state, action) => {
      state.filterDropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addMediaTypeStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getBreDropdown: (state, action) => {
      state.BreDropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.systemNotesStatus = null;
      state.isSystemNoteLoading = false;
      state.mediaTypePrintStatus = null;
    },
    resetData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.saveDataManagerStatus = null;
      state.isSystemNoteLoading = false;
      state.fetchedDataManager = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  postMediaTypeData,
  getDataManager,
  fetchSuccess,
  fetchError,
  resetMessage,
  getDropDownData,
  postSystemNotesData,
  resetStatus,
  resetData,
  getBreDropdown,
  postMediaTypeAddData,
  fetchAddSuccess,
  resetRecordStatus,
  fetchNoteStart,
  getMediaTypeUsageData,
  setMediaTypePrintData,
  resetMediaUsagedata,
  saveDataManager,
} = slice.actions;


export const postDataManager = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('datamanager/save/datamanager', details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(saveDataManager(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchMediaTypeUsage = (name) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`integrationmedia/get/usageintegrationmedia/${name}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getMediaTypeUsageData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postMediaType = (values) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`integrationmedia/save/integrationmedia`, values)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          dispatch(postMediaTypeAddData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postMediaTypeData(data));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const printMediaType = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`integrationmedia/print/mediatype`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPrintMediaType({dockey: data?.message}, data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};


export const postPrintMediaType = (payload, postMediaTypeData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`integrationmedia/generateurlprintmediatype`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(setMediaTypePrintData(postMediaTypeData));
          download(data.data);
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};


export const fetchFilterDropdownData = (recordType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmfilter/findall/filtercode/${recordType}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getDropDownData(data.data));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchBreCodeAndDescription = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/get/all/brecode`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getBreDropdown(data?.response));
          dispatch(fetchSuccess(data?.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchDataManager = (dmCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`datamanager/get/datamanager/${dmCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getDataManager(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    httpPost(`integrationmedia/save/mediatypenotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};
export const ResetAddRecord = () => {
  return (dispatch) => {
    dispatch(resetRecordStatus());
  };
};
